import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';

export const chartLegendTheme: ThemeOptions['components'] = {
  DsChartLegend: {
    styleOverrides: {
      root: () => ({
        borderRadius: tokens.theme.radius.xs,
        verticalAlign: 'middle',
        boxSizing: 'border-box',
      }),

      // Variant
      filled: ({ ownerState }) => ({
        background: ownerState.color,
        border: `1px solid ${ownerState.color}`,
      }),
      outlined: ({ ownerState }) => ({
        background: 'none',
        border: `1px solid ${ownerState.color}`,
      }),

      // Size
      lg: {
        width: '12px',
        height: '12px',
      },
      md: {
        width: '12px',
        height: '12px',
      },
      sm: {
        width: '8px',
        height: '8px',
      },
    },
  },
};
